import { render, staticRenderFns } from "./dublist.vue?vue&type=template&id=9b9b4ba6&"
import script from "./dublist.vue?vue&type=script&lang=js&"
export * from "./dublist.vue?vue&type=script&lang=js&"
import style0 from "./dublist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports